import React from 'react'
import styles from './customSwitch.module.scss'
import { useMobileViewport } from '../../../../../util/mobileViewPort';
import { Tracker } from '../../../../../util/analytics';
import { getUser, getRole } from "../../../../../util/helpers";

const CustomSwitch = (props) => {
  const { onClickHandler, state, path } = props;
  const isMobile = useMobileViewport();
  return (
    <div onClick={(event) => {
      event.stopPropagation();
      if (path) {
        Tracker.event(
          "Toggle",
          state ? "switch_to_new" : "switch_to_old",
          "toggle_switch",
          `${new Date()}__${path}__${getRole()}`,
          getUser()
        );
      }
      onClickHandler();
    }}
      className={`${styles.custom__switch__base} ${state ? styles.active : ''}`}>
      <div className={`${styles.custom__switch__circle} ${state ? styles.active : ''}`}></div>
    </div>
  )
}

export default CustomSwitch